import type { ReportDefinition } from '@goyone/shared';
import { api } from './api';

/**
 * تصديرُ تقريرٍ ملفًّا — من أيّ بطاقةٍ أو من الباني.
 *
 * عبر `api` لا رابطٍ مباشر: رمزُ الوصول في الترويسة لا في كوكي، فالرابطُ
 * العاري يعود 401. والاسمُ من الخادم (في Content-Disposition) — ويُستخرج
 * منه، وإلّا فاسمٌ افتراضيّ.
 */
export async function exportReport(
  definition: ReportDefinition,
  title: string,
  format: 'xlsx' | 'csv',
): Promise<void> {
  const blob = await api<Blob>('/reports/export', {
    method: 'POST',
    body: { definition, title, format },
    raw: true,
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${title.replace(/[\\/:*?"<>|]+/g, ' ').trim() || 'تقرير'}.${format}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** مسارُ صفحة الطباعة (PDF من المتصفّح) لتعريفٍ بعينه. */
export function printReportPath(definition: ReportDefinition, title: string): string {
  const params = new URLSearchParams({ def: JSON.stringify(definition), title });
  return `/print/report?${params.toString()}`;
}
